var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CarDetails',_vm._g({attrs:{"carList":_vm.sortedCars,"selectedIndex":_vm.bubble.userPref,"trips":_vm.trips,"bubble":_vm.bubble,"currentCar":_vm.currentCar},on:{"change":_vm.updateSelected}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }